import React, { useEffect, useState } from 'react'
import videoslash from '../../../include/images/video-slash.svg'
import messageIcon from '../../../include/images/tab-message.svg'
import videosOn from '../../../include/images/Videoon.png'
import documentIcon from '../../../include/images/tab-document.svg'
import notesIcon from '../../../include/images/notes-icon.svg'
import taskIcon from '../../../include/images/tab-dashboard.svg'
import micOn from '../../../include/images/micon.png'
import Document from './../../patient/dashboard/postAppointment/activity/documents'
import phoneslash from '../../../include/images/phone-slash.svg'
import mindy from '../../../include/images/YM_Character_4.svg'
import shareIcon from '../../../include/images/share.svg'
import shareClose from '../../../include/images/share_close.svg'
import iosExit from '../../../include/images/ios-exit.svg'
import rotate from '../../../include/images/camera-rotate-solid-full.svg'
import fullScreenImg from '../../../include/images/fullscreen-icon.svg'
import Timer from '../../common/timer'
import moment from 'moment'
import {
  checkCallStatus,
  getAppointment,
  loadAppointmentDetailPatient,
} from '../../../store/appointment'
import { loadSeo, loadTermTemplate } from '../../../store/seo'
import { getDoctor, loadDoctorProfile } from '../../../store/doctor'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import DashboardHeader from '../profile/common/dashboardHeader'
import Messeges from './postAppointment/activity/messeges'
import Notes from './postAppointment/activity/notes'

import TermTemplatePopup from '../../common/termTemplatePopup'
//import Task from "./timeline/task";
import Task from './postAppointment/activity/task'

import AvtarImage from '../../common/avtarImage'
import { getPatient } from '../../../store/patient'
import LinesEllipsis from 'react-lines-ellipsis'
import { Tooltip as ReactTooltip } from 'react-tooltip'

import LoadVideoCall from '../../video-call/loadVideoCall';
import LoadScreenShare from '../../video-call/loadScreenShare';
import { collection, query, where, getDocs } from "firebase/firestore";
import '../../doctor/dashboard/style.css'
import { db } from '../../../firebase'
import { toast } from 'react-toastify'
import AlertSuccess from '../../common/alertSuccess'
import AgoraRTC from "agora-rtc-sdk-ng";

function VideoCallPatient(props) {
  const [popShow, setPopShow] = useState(false)
  const [data, setData] = useState({
    patient_id: {},
    doctor_id: { field_type: {} },
  })
  const [video, setVideo] = useState(true)
  const [audio, setAudio] = useState(true)
  const [fullScreen, setFullScreen] = useState(false)
  const [tab, setTab] = useState('notes')
  const [localMedia, setLocalMedia] = useState([])
  const [screenShare, setScreenShare] = useState(false);
  const [userToken, setUserToken] = useState({});
  const [client, setClient] = useState();
  const [loadContent, setLoadContent] = useState();
  const [showUnreadDot, setShowUnreadDot] = useState(false);
  const [cameraDevices, setCameraDevices] = useState([]);
  const [currentCameraId, setCurrentCameraId] = useState(null);

  const changeTab = (tab, e) => {
    e.preventDefault()
    setTab(tab)
  }
  const toggleFull = () => {
    setFullScreen(!fullScreen)
  }
  const togglePopup = () => {
    setPopShow(!popShow)
  }
  const openPopup = (e, key) => {
    if (e) e.preventDefault()
    props.loadTermTemplate(key)
    togglePopup()
  }

  const muteVideo = () => {
    if (localMedia.length > 1) {
      if (video) {
        localMedia[1].setEnabled(false)
      } else {
        localMedia[1].setEnabled(true)
      }
    }
    setVideo(!video)
  }

  const muteAudio = () => {
    if (localMedia.length > 1) {
      if (audio) {
        localMedia[0].setVolume(0)
        //localStream.muteAudio();
      } else {
        localMedia[0].setVolume(100)
        //localStream.unmuteAudio();
      }
    }
    setAudio(!audio)
  }
  
  async function switchCamera() {
    if (!localMedia || localMedia.length < 2) {
      console.warn("No video track found.");
      return;
    }

    const localVideoTrack = localMedia[1];

    try {
      const devices = await AgoraRTC.getCameras();
      setCameraDevices(devices);

      if (devices.length < 2) {
        alert("Only one camera found");
        return;
      }

      const currentIndex = devices.findIndex(d => d.deviceId === currentCameraId);
      const nextIndex = (currentIndex + 1) % devices.length;
      const nextCamera = devices[nextIndex];

      await localVideoTrack.setDevice(nextCamera.deviceId);
      setCurrentCameraId(nextCamera.deviceId);

      console.log("Switched to:", nextCamera.label || nextCamera.deviceId);
    } catch (err) {
      console.error("Error switching camera:", err);
      alert("Unable to switch camera. Please check permissions.");
    }
  }

  const leave = async () => {
    if (localMedia.length > 1) {
      localMedia[0].close()
      localMedia[1].close()
    }
    window.close()
  }
  const handleScreenShareStart = async ()=>{
    if(!screenShare){
      await client.leave();
      props.loadAppointmentDetailPatient(
        props.match.params.appointment_id,
        res => {
          if (res && res.data) {
            setScreenShare(true);
            setUserToken({
              screenShare:true,
              token:res.data.tokenA,
              uid:res.data.uid
            });
          }
        }
      )
    }
  }
  const handleScreenShareEnd = async ()=>{
    if(screenShare){
      localMedia.map(l=>l.close())
      //localMedia[1].close()
      await client.leave();
      window.location.reload();
      props.loadAppointmentDetailPatient(
        props.match.params.appointment_id,
        res => {
          if (res && res.data) {
            setScreenShare(false);
            setUserToken({
              screenShare:false,
              token:res.data.tokenA,
              uid:res.data.uid
            });
          }
        }
      )
    }
  }
    const getTime = (time) => {
    const hours = Math.floor(time / 3600000);
    const minutes = Math.floor((time % 3600000) / 60000);
    const seconds = Math.floor((time % 60000) / 1000);

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };

  useEffect(() => {
    openPopup(null, 'userConsentForm')
    props.loadAppointmentDetailPatient(
      props.match.params.appointment_id,
      res => {
        if (res && res.data) {
          setData(res.data.data)
          setUserToken({
            screenShare:false,
            token:res.data.tokenA,
            uid:res.data.uid
          })
        }
      }
    )
  }, []);

useEffect(() => {
  let pollInterval;

  const pollForDoctorJoin = () => {
    props.checkCallStatus(
      props.match.params.appointment_id,
      res => {
        if (res?.data?.call_started_at) {
          clearInterval(pollInterval);
          startCallTimer(res.data);
        }
      }
    );
  };

  pollInterval = setInterval(pollForDoctorJoin, 3000);
  pollForDoctorJoin();

  return () => clearInterval(pollInterval);
}, []);


const startCallTimer = appt => {
  console.log("reached to startCallTimer--->");

  if (!appt?.duration || !appt?.call_started_at) return;

  const callStart = new Date(appt.call_started_at).getTime();
  const duration = appt.duration * 60 * 1000;
  const callEnd = callStart + duration;
  const warningTime = callEnd - 5 * 60 * 1000;

  const now = Date.now();

  console.log("Time left ----->", getTime(warningTime - now));

  if (now >= warningTime) {
    toast.warning("Your appointment has less than 5 mins.", {
      autoClose: false,
      closeOnClick: true,
      icon: <img src={mindy} alt="mindy" style={{ transform: "scale(4)" }} />,
    });
    return;
  }

  if(now <= warningTime) {
    setTimeout(() => {
      toast.warning("Your appointment has 5 mins left.", {
        autoClose: false,
        closeOnClick: true,
        icon: <img src={mindy} alt="mindy" style={{ transform: "scale(4)" }} />,
      });
    }, warningTime - now);
  }
};

  const getVideoContent = ()=>{
    return (   
      <LoadVideoCall 
        setLocalMedia={setLocalMedia} 
        channel={data._id}
        userToken={userToken}
        setClient={setClient}
        screenShare={screenShare}
        userType={"patient"}
        />
      )
    }
  const getScreenShareContent = ()=>{
    return (      
        <LoadScreenShare 
          localMedia={localMedia} 
          setLocalMedia = {setLocalMedia}
          channel={data._id}
          userToken={userToken}
          shareScreen={handleScreenShareEnd}
          setClient={setClient}
          screenShare={screenShare}
        />
    )
  }
  useEffect(()=>{
    if(Object.keys(userToken).length > 0){
      if(userToken.screenShare) setLoadContent(getScreenShareContent())
      else setLoadContent(getVideoContent())
    }
  },[userToken])

  useEffect(() => {
    const classData = document.getElementsByClassName('mcb-body-fullscreen')
    const topDar = document.getElementsByClassName('dashboard-top-bar')
    if (classData.length > 0 && topDar && topDar.length > 0) {
      topDar[0].style.zIndex = -999
    } else if (topDar && topDar.length > 0) {
      topDar[0].style.zIndex = 999
    }
    let localVideoTrack = localMedia && localMedia.length > 0 && localMedia[1]
    if (localVideoTrack) {
      if (fullScreen) {
        let localPlayerContainer = document.getElementById('agora_local_full')
        localPlayerContainer.innerHTML = ''
        localVideoTrack.play(localPlayerContainer)
      } else {
        let localPlayerContainer = document.getElementById('agora_local')
        localPlayerContainer.innerHTML = ''
        localVideoTrack.play(localPlayerContainer)
      }
    }
  }, [fullScreen])

  const loadNotification = async () => {
    if (!data?.patient_id?._id) return;

    const q = query(
      collection(db, "chatsSummary"),
      where("patientId", "==", data.patient_id?._id),
      where("readByPatient", "==", false)
    );

    const snapshot = await getDocs(q);
    if (!snapshot.empty) {
      setShowUnreadDot(true);
    } else {
      setShowUnreadDot(false);
    }
  };

  useEffect(() => {
    loadNotification();
    const pollInterval = setInterval(() => {
      loadNotification();
    }, 5000);

    // cleanup on unmount
    return () => clearInterval(pollInterval);
  }, [data.patient_id?._id]); 

  useEffect(() => {
    if(showUnreadDot){
      toast.info('You got a new message!', {
        autoClose: false,
        closeOnClick: true, 
        icon: <img src={mindy} alt="mindy" style={{ transform: "scale(4)" }}/>,
      })
    }
  }, [showUnreadDot])

  useEffect(() => {
    (async () => {
      const devices = await AgoraRTC.getCameras();
      // console.log("devices----> ", devices)
      setCameraDevices(devices);
      if (devices[0]) setCurrentCameraId(devices[0].deviceId);
    })();
  }, []);


  return (
    <>
      {/* <Helmet>
        <script id='wati'>{WatiScript}</script>
      </Helmet> */}

      <DashboardHeader />

      {/* <ReactTooltip id='my-tooltip' className='testPurple' /> */}

      {data && data.doctor_id && data.doctor_id._id && (
        <div class='dashboard-main-container patient-class'>
          {/* {JSON.stringify(
              props.getPatient.lastFollowup &&
                props.getPatient.lastFollowup.formData &&
                props.getPatient.lastFollowup.formData[
                  "Current Complaints:"
                ]
            )} */}
          <div class='video-box d-xl-flex flex-wrap'>
            <div
              className={
                fullScreen
                  ? 'main-content-box main-content-box3'
                  : 'main-content-box '
              }>
              <div class='mcb-head'>
                <ReactTooltip
                  id='videoToolTip1'
                  multiline={true}
                  className='testPurple'
                />
                <ul class='doc-intro-list d-md-flex flex-wrap'>
                  <li class='di-item'>
                    <div class='di-intro d-flex flex-wrap align-items-center'>
                      <div class='di-img'>
                        {data.doctor_id.image_url ? (
                          <img
                            src={
                              process.env.REACT_APP_S3URL +
                              data.doctor_id.image_url
                            }
                            alt=''
                          />
                        ) : (
                          <AvtarImage />
                        )}
                      </div>
                      <div class='di-text-box'>
                        <h6>{data && data.doctor_id && data.doctor_id.name}</h6>
                        <p>
                          {' '}
                          {data &&
                            data.doctor_id &&
                            data.doctor_id.field_type &&
                            data.doctor_id.field_type.name}
                          {data &&
                            data.doctor_id &&
                            data.doctor_id.graduation &&
                            ', ' + data.doctor_id.graduation.education}
                          {data &&
                            data.doctor_id &&
                            data.doctor_id.post_graduation &&
                            ', ' + data.doctor_id.post_graduation.education}
                          {data &&
                            data.doctor_id &&
                            data.doctor_id.super_speciality &&
                            ', ' + data.doctor_id.super_speciality.education}
                        </p>
                      </div>
                    </div>
                  </li>
                  <li
                    class='di-item'
                    data-tooltip-id='videoToolTip1'
                    data-tooltip-content={
                      props.getPatient &&
                      props.getPatient.lastPrescriptionOfBoth[
                        data.doctor_id.field_type.name
                      ] &&
                      Object.keys(
                        props.getPatient.lastPrescriptionOfBoth[
                          data.doctor_id.field_type.name
                        ]
                      ).length > 0
                        ? props.getPatient.lastPrescriptionOfBoth[
                            data.doctor_id.field_type.name
                          ] &&
                          props.getPatient.lastPrescriptionOfBoth[
                            data.doctor_id.field_type.name
                          ].chief_complaints &&
                          typeof props.getPatient.lastPrescriptionOfBoth[
                            data.doctor_id.field_type.name
                          ].chief_complaints === 'string'
                          ? props.getPatient.lastPrescriptionOfBoth[
                              data.doctor_id.field_type.name
                            ].chief_complaints
                          : props.getPatient.lastPrescriptionOfBoth[
                              data.doctor_id.field_type.name
                            ].chief_complaints &&
                            props.getPatient.lastPrescriptionOfBoth[
                              data.doctor_id.field_type.name
                            ].chief_complaints.length > 0
                          ? props.getPatient.lastPrescriptionOfBoth[
                              data.doctor_id.field_type.name
                            ].chief_complaints &&
                            props.getPatient.lastPrescriptionOfBoth[
                              data.doctor_id.field_type.name
                            ].chief_complaints
                              .map(ec => ec.value)
                              .join(', ')
                          : 'NA'
                        : 'NA'
                    }>
                    <h3>Current Complaints:</h3>
                    <p>
                      <LinesEllipsis
                        text={
                          props.getPatient &&
                          props.getPatient.lastPrescriptionOfBoth[
                            data.doctor_id.field_type.name
                          ] &&
                          Object.keys(
                            props.getPatient.lastPrescriptionOfBoth[
                              data.doctor_id.field_type.name
                            ]
                          ).length > 0
                            ? props.getPatient.lastPrescriptionOfBoth[
                                data.doctor_id.field_type.name
                              ] &&
                              props.getPatient.lastPrescriptionOfBoth[
                                data.doctor_id.field_type.name
                              ].chief_complaints &&
                              typeof props.getPatient.lastPrescriptionOfBoth[
                                data.doctor_id.field_type.name
                              ].chief_complaints === 'string'
                              ? props.getPatient.lastPrescriptionOfBoth[
                                  data.doctor_id.field_type.name
                                ].chief_complaints
                              : props.getPatient.lastPrescriptionOfBoth[
                                  data.doctor_id.field_type.name
                                ].chief_complaints &&
                                props.getPatient.lastPrescriptionOfBoth[
                                  data.doctor_id.field_type.name
                                ].chief_complaints.length > 0
                              ? props.getPatient.lastPrescriptionOfBoth[
                                  data.doctor_id.field_type.name
                                ].chief_complaints &&
                                props.getPatient.lastPrescriptionOfBoth[
                                  data.doctor_id.field_type.name
                                ].chief_complaints
                                  .map(ec => ec.value)
                                  .join(', ')
                              : 'NA'
                            : 'NA'
                        }
                        maxLine='2'
                        ellipsis='...'
                        trimRight
                        basedOn='letters'
                      />
                    </p>
                  </li>
                  {/* <li
                    class='di-item'
                    data-tooltip-id='videoToolTip1'
                    data-tooltip-content={
                      props.getPatient.prevPsychiatristPrescription &&
                      props.getPatient.prevPsychiatristPrescription
                        .medical_prescription &&
                      props.getPatient.prevPsychiatristPrescription
                        .medical_prescription.length > 0 &&
                      props.getPatient.prevPsychiatristPrescription
                        .medical_prescription[0].composition
                        ? props.getPatient.prevPsychiatristPrescription.medical_prescription
                            .map(
                              elp =>
                                elp.formulation +
                                ' ' +
                                elp.composition +
                                ' ' +
                                elp.dose
                            )
                            .join(', ')
                        : 'NA'
                    }>
                    <h3>Last advise:</h3>
                    <p>
                      {data &&
                      data.doctor_id &&
                      data.doctor_id.field_type &&
                      data.doctor_id.field_type.name &&
                      data.doctor_id.field_type.name === 'Psychologist' ? (
                        <LinesEllipsis
                          text={
                            props.getPatient.prevPsychologistPrescription &&
                            props.getPatient.prevPsychologistPrescription
                              .theray_method
                              ? props.getPatient.prevPsychologistPrescription
                                  .theray_method
                              : 'NA'
                          }
                          maxLine='2'
                          ellipsis='...'
                          trimRight
                          basedOn='letters'
                        />
                      ) : (
                        <LinesEllipsis
                          text={
                            props.getPatient.prevPsychiatristPrescription &&
                            props.getPatient.prevPsychiatristPrescription
                              .medical_prescription &&
                            props.getPatient.prevPsychiatristPrescription
                              .medical_prescription.length > 0 &&
                            props.getPatient.prevPsychiatristPrescription
                              .medical_prescription[0].composition
                              ? props.getPatient.prevPsychiatristPrescription.medical_prescription
                                  .map(
                                    elp =>
                                      elp.formulation +
                                      ' ' +
                                      elp.composition +
                                      ' ' +
                                      elp.dose
                                  )
                                  .join(', ')
                              : 'NA'
                          }
                          maxLine='2'
                          ellipsis='...'
                          trimRight
                          basedOn='letters'
                        />
                      )}
                    </p> 
                  </li> */}
                </ul>
              </div>
              
              <div
                class={`call-end ${
                  fullScreen ? 'mcb-body-fullscreen' : 'mcb-body'
                }`}>
                
                {loadContent}

                {!fullScreen && (
                  <>
                    <div
                      class='fullscreen-button'
                      style={{ cursor: 'pointer' }}
                      onClick={() => toggleFull()}>
                      <img src={fullScreenImg} alt='' />
                    </div>
                    <div id='agora_local' class='front-thumbnail-box'></div>
                  </>
                )}
              </div>
              
              {fullScreen && (
                <>
                  <div
                    class='fullscreen-button'
                    style={{ cursor: 'pointer' }}
                    onClick={() => toggleFull()}>
                    <img src={fullScreenImg} alt='' />
                  </div>
                  <div id='agora_local_full' class='front-thumbnail-box'></div>
                </>
              )}

              <div class={`${fullScreen ? 'mcb-footer-fullscreen' : ''} `}>
                <div className={`${fullScreen ? 'mb-foor-app' : ''} `}>
                  <div class='mcb-footer d-flex align-items-center justify-content-between'>
                    <div class='mcb-left'>
                      {moment().format('MMMM Do, YYYY')}
                    </div>
                    <div class='mcb-mid d-flex align-items-center flex-wrap'>
                      <div class='mcb-link' onClick={muteVideo}>
                        <div class='img'>
                          <img src={!video ? videoslash : videosOn} alt='' />
                        </div>
                        <p>Camera</p>
                      </div>
                      <div class='mcb-link' onClick={muteAudio}>
                        <div class='img'>
                          <img src={!audio ? phoneslash : micOn} alt='' />
                        </div>
                        <p>Mic</p>
                      </div>
                      
                      <div
                        class='mcb-link'
                        onClick={()=>{
                          if(!screenShare) handleScreenShareStart();
                          else handleScreenShareEnd();
                        }}
                      >
                        <div class='img'>
                          <img
                            src={!screenShare ? shareIcon : shareClose}
                            alt=''
                          />
                        </div>
                        <p>share</p>
                      </div>
                      <div class='mcb-link leave' onClick={leave}>
                        <div class='img'>
                          <img src={iosExit} alt='' />
                        </div>
                        <p>Leave</p>
                      </div>
                      <div class='mcb-link' onClick={switchCamera}>
                        <div class='img'>
                          <img src={rotate} alt='' />
                        </div>
                        <p>Rotate</p>
                      </div>
                    </div>
                    <div class='mcb-right'>
                      <Timer />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {!fullScreen && (
              <div class='video-sidebar video-sidebar2'>
                <div class='vs-box'>
                  <div class='tab-container d-none d-md-block'>
                    <ul
                      class='nav nav-tabs videochat-tabs'
                      id='myTab'
                      role='tablist'>
                      <li
                        class='nav-item'
                        role='presentation'
                        data-tooltip-id='videoToolTip1'
                        data-tooltip-content='You can message your experts for up to 3 days after every appointment.'>
                        <a
                          class={
                            tab === 'message' ? 'nav-link active' : 'nav-link'
                          }
                          id='messages-tab'
                          data-toggle='tab'
                          href='#messages'
                          role='tab'
                          aria-controls='messages'
                          aria-selected='true'
                          onClick={e => changeTab('message', e)}>
                          {showUnreadDot && (
                            <span style={{
                              position: 'absolute',
                              top: 20,
                              left: 15,
                              height: '10px',
                              width: '10px',
                              backgroundColor: '#8BB044',
                              borderRadius: '50%',
                              display: 'inline-block'
                            }}></span>
                          )}  
                          <i className="fa-solid fa-message-dots fa-lg" style={{ color: "#673ab7" }}></i>
                          <b>Messages</b>
                        </a>
                      </li>

                      <li
                        class='nav-item'
                        role='presentation'
                        data-tooltip-id='videoToolTip1'
                        data-tooltip-content='Reports/ Past prescriptions can be shared from here with your                                                                                          
                experts.'>
                        <a
                          class={
                            tab === 'documents' ? 'nav-link active' : 'nav-link'
                          }
                          id='profile-tab'
                          data-toggle='tab'
                          href='#mySummary'
                          role='tab'
                          aria-controls='mySummary'
                          aria-selected='false'
                          onClick={e => changeTab('documents', e)}>
                          {' '}
                          <i className="fa-thumbprint fa-light fa-file fa-lg" style={{ "--fa-primary-color": "#673ab7", "--fa-secondary-color": "#673ab7" }}></i>
                          <b>My Reports</b>{' '}
                        </a>
                      </li>
                      <li
                        class='nav-item'
                        role='presentation'
                        data-tooltip-id='videoToolTip1'
                        data-tooltip-content='Notes & Thoughts'>
                        <a
                          class={
                            tab === 'notes' ? 'nav-link active' : 'nav-link'
                          }
                          id='contact-tab'
                          data-toggle='tab'
                          href='#myNotes'
                          role='tab'
                          aria-controls='myNotes'
                          aria-selected='false'
                          onClick={e => changeTab('notes', e)}>
                          {' '}
                          <i className="fa-solid fa-thought-bubble fa-lg" style={{ color: "#673ab7" }}></i>
                          <b>Notes & Thoughts</b>{' '}
                        </a>
                      </li>
                      <li
                        class='nav-item'
                        role='presentation'
                        data-tooltip-id='videoToolTip1'
                        data-tooltip-content='When task is allotted by your expert it will be visible here till  
                Completed and submitted. Find completed tasks under timeline.'>
                        <a
                          class={
                            tab === 'tasks' ? 'nav-link active' : 'nav-link'
                          }
                          id='contact-tab'
                          data-toggle='tab'
                          href='#myTasks'
                          role='tab'
                          aria-controls='myTasks'
                          aria-selected='false'
                          onClick={e => changeTab('tasks', e)}>
                          {' '}
                          <i className="fa-sharp-duotone fa-list-check fa-lg" style={{ "--fa-primary-color": "#673ab7", "--fa-secondary-color": "#673ab7" }}></i>
                          <b>Tasks</b>{' '}
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class='chatbot-body p-md-0'>
                    <div class='tab-content' id='myTabContent'>
                      <div
                        class={
                          tab === 'message'
                            ? 'tab-pane card fade show active'
                            : 'tab-pane card'
                        }
                        id='messages'
                        role='tabpanel'
                        aria-labelledby='messages-tab'>
                        <Messeges
                          showUnreadDot={showUnreadDot}
                          doctor_id={data.doctor_id._id}
                          patient_id={
                            JSON.parse(localStorage.getItem('patient'))._id
                          }
                          tab={tab}
                          setTab={changeTab}
                        />
                      </div>
                      <div
                        class={
                          tab === 'documents'
                            ? 'tab-pane card fade show active'
                            : 'tab-pane card'
                        }
                        id='messages'
                        role='tabpanel'
                        aria-labelledby='messages-tab'>
                        <Document
                          videoCall={true}
                          tab={tab}
                          setTab={changeTab}
                        />
                      </div>

                      <div
                        class={
                          tab === 'notes'
                            ? 'tab-pane card fade show active'
                            : 'tab-pane card'
                        }
                        id='messages'
                        role='tabpanel'
                        aria-labelledby='messages-tab'>
                        <Notes
                          aapointment_id={props.match.params.appointment_id}
                          doctor_id={data.doctor_id._id}
                          tab={tab}
                          setTab={changeTab}
                        />
                      </div>

                      <div
                        class={
                          tab === 'tasks'
                            ? 'tab-pane card fade show active'
                            : 'tab-pane card'
                        }
                        id='messages'
                        role='tabpanel'
                        aria-labelledby='messages-tab'>
                        {data && data.doctor_id && data.doctor_id._id && (
                          <Task
                            videoCall={true}
                            aapointment_id={props.match.params.appointment_id}
                            doctor_id={data.doctor_id._id}
                            tab={tab}
                            setTab={changeTab}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      <TermTemplatePopup consent={true} show={popShow} toggle={togglePopup} />
    </>
  )
}
const mapDispatchToProps = dispatch => ({
  loadSeo: page_key => dispatch(loadSeo(page_key)),
  loadDoctorProfile: () => dispatch(loadDoctorProfile()),
  loadTermTemplate: params => dispatch(loadTermTemplate(params)),
  loadAppointmentDetailPatient: (id, callback) =>
    dispatch(loadAppointmentDetailPatient(id, callback)),
  checkCallStatus: (id, callback) =>
    dispatch(checkCallStatus(id, callback)),
})
const mapStateToProps = state => ({
  profileLoading: getDoctor(state).profileLoading,
  getPatient: getPatient(state),
  doctorProfile: getDoctor(state).profile,
  getAppointment: getAppointment(state).doctorAppointment,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(VideoCallPatient)
)
